export default __webpack_public_path__ + "assets/langSwitcher7.png";